export const copyToClipboard = async (text: string, cb: any) => {
  // if (!navigator.clipboard) return
  navigator.clipboard.writeText(text).then(() => {
    // console.log('Async: Copying to clipboard was successful!')
    if (typeof cb === 'function') {
      cb()
    }
  })
}
